import { render, staticRenderFns } from "./RoundFilter.vue?vue&type=template&id=5c16d9ea&scoped=true&"
import script from "./RoundFilter.vue?vue&type=script&lang=js&"
export * from "./RoundFilter.vue?vue&type=script&lang=js&"
import style0 from "./RoundFilter.vue?vue&type=style&index=0&id=5c16d9ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c16d9ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
